import { TextInput } from "@mantine/core";
import { useField } from ".";

type Props = {
  name: string;
  label?: string;
  disabled?: boolean;
  placeholder: string;
  onChangeCustom?: any;
  rightSection?: React.ReactNode;
  classNames?: Partial<Record<string, string>> | undefined;
  size?: any;
  variant?: any;
  className?: any;
  styles?: any;
  radius?: any;
  withAsterisk?: boolean;
  icon?: React.ReactNode;
  readOnly?: boolean;
  w?: string | number;
  nullable?: boolean;
  required?: boolean;
  maxLength?: number;
  max?: number;
  noError?: boolean;
};

export function TextField({
  name,
  label,
  placeholder,
  disabled = false,
  onChangeCustom,
  rightSection,
  classNames,
  size,
  variant,
  className,
  styles,
  radius,
  withAsterisk = false,
  icon,
  readOnly = false,
  nullable,
  w,
  required = false,
  noError = false,
  maxLength,
  max,
}: Props) {
  const { value, error, onChange } = useField(name);

  return (
    <TextInput
      w={w}
      readOnly={readOnly}
      leftSection={icon}
      variant={variant}
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      error={error}
      value={value}
      size={size}
      radius={radius}
      rightSection={rightSection}
      classNames={classNames}
      onChange={(e) => {
        onChange(e.target.value);
        onChangeCustom && onChangeCustom(e.target.value);
      }}
      className={className}
      required={required}
      withAsterisk={required}
      maxLength={maxLength}
      max={max}
      styles={{
        error: {
          display: noError ? "none" : "block",
        },
        wrapper: {
          marginBottom: noError && error && 0,
        },
        ...styles,
      }}
    />
  );
}
